import React, { Component } from 'react';

import Site, {SiteModifier_} from '../utils/Site'
import Each from '../utils/Each'
import withData from '../utils/withData'
import {Form} from '../components/Forms'
import SingleInput from '../components/Forms/SingleInput'

import {
  Link
} from 'react-router-dom';

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Button from '../components/Button'
import Image from '../components/Image'
import Filters from '../components/Filters'
import EventsList from '../components/EventsList'
import FadeIn from '../components/FadeIn'
import OpeningTimes from '../components/OpeningTimes'
import CallToAction from '../components/CallToAction'
import Happenings from '../components/Happenings'
import Rates from '../components/Rates'
import LiveGallery from '../components/LiveGallery'
import ContentBlocks from '../components/ContentBlocks'
import MiniMap from '../components/MiniMap'
import Window from '../components/Window'

import Asset from '../models/Asset'
import Entry from '../models/Entry'

require('../helpers/Array.js');



class Promotion extends Component {

	constructor(props)
  {
    super(props)
    this.state = {
      name: '',
      email: '',
      isComplete: false
    }
  }

  isComplete = () => {
    if(this.state.name &&
      this.state.email)
    {
      this.setState({isComplete:false})
    } else {
      this.setState({isComplete:true})
    }
  }

  handleNameChange = (evt) => {
    this.setState({
      name: evt.target.value
    });
    this.isComplete();
  }

  handleEmailChange = (evt) => {
    this.setState({
      email: evt.target.value
    });
    this.isComplete();
  }

  handleSubmit = (evt) => {
    evt.preventDefault();

    let {name,email,selectedOption} = this.state

    /*Jquery.post('http://thefenway.archivestud.io/subscribe/',{
      name: name,
      email: email,
      reason: selectedOption
    }, function(response)
    {
      if(response == 201)
            {
              window.location = '/thanks'
            }

           */
    }

	


	/*

		RENDER

	*/

	render() {

		let {entry} = this.props


		return (
			<FadeIn>
			<div className={"Template  Template--default Template--promo"}>

			{/* Template-body */}
					<div className="Template-body">



						<div className="Template-sections">

					{/* Template-section */}
							<div className="Template-section  Template-section--full  Template-section--container">
								<div className="Template-heading">
									<Content html={'<h1>'+entry.brand+'</h1>'} modifier="promo"/>
									<Content html={entry.summary} modifier="promo"/>
								</div>
								<form class="Form" onSubmit={this.handleSubmit}>
								<div className="Template-content">
									 <div className="Newsletter-form">
								          <SingleInput className={'Form-input'} inputType={'text'} title={'Full Name'} name={'name'} placeholder={'Name:'} value={this.state.name} onChange={this.handleNameChange}/>
								          <SingleInput className={'Form-input'} inputType={'text'} title={'Email'} name={'email'} placeholder={'Email Address:'} value={this.state.email} onChange={this.handleEmailChange} />
								          <SingleInput className={'Form-submit'} inputType={'submit'} title={'Claim it!'} name={'Claim it!'} value={'Claim it!'} />
								        </div>
								</div>
								</form>
							</div>
							{/* / Template-section */}

						</div>

					</div>


			</div>
			</FadeIn>
		);

	}
}

export default withData(Promotion);



// WEBPACK FOOTER //
// ./src/js/templates/Promotion.jsx